import React, { useEffect, useState, useCallback } from "react";
import * as XLSX from "xlsx";

const API = "https://vms.hexagons.tech/api";

// 🔥 MAPEO
const statusMap = {
  inside: "Dentro",
  exited: "Salida"
};

export default function Report() {
  const [visitors, setVisitors] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const token = localStorage.getItem("token");

  const fetchReports = useCallback(async () => {
    try {
      const res = await fetch(`${API}/reports`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!res.ok) throw new Error("Error al obtener reportes");

      const data = await res.json();

      if (Array.isArray(data)) {
        setVisitors(data);
        setFiltered(data);
      }
    } catch (err) {
      console.error(err);
    }
  }, [token]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  const applyFilter = () => {
    if (!startDate || !endDate) {
      setFiltered(visitors);
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59);

    const result = visitors.filter((v) => {
      const entry = new Date(v.entryTime);
      return entry >= start && entry <= end;
    });

    setFiltered(result);
  };

  // 🔥 EXPORT COMPLETO
  const exportToExcel = () => {
    const data = filtered.map((v) => ({
      Nombre: v.name,
      Cedula: v.idNumber,
      Empresa: v.company,
      Departamento: v.department,
      Motivo: v.reason,
      Detalle: v.reasonDetail || "-",
      Entrada: v.entryTime
        ? new Date(v.entryTime).toLocaleString()
        : "-",
      Salida: v.exitTime
        ? new Date(v.exitTime).toLocaleString()
        : "-",
      Estado: statusMap[v.status] || v.status
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reportes");
    XLSX.writeFile(wb, "Reporte.xlsx");
  };

  return (
    <div className="p-4 md:p-6 space-y-6 bg-background min-h-screen">

      <h1 className="text-2xl font-bold text-primary">Reportes</h1>

      {/* FILTROS */}
      <div className="bg-white p-5 rounded-2xl shadow border-l-4 border-primary">
        <div className="flex gap-3 flex-wrap">

          <input
            type="date"
            className="border p-2 rounded"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <input
            type="date"
            className="border p-2 rounded"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <button
            onClick={applyFilter}
            className="bg-primary text-white px-4 py-2 rounded"
          >
            Filtrar
          </button>

          <button
            onClick={exportToExcel}
            className="bg-success text-white px-4 py-2 rounded"
          >
            Exportar
          </button>

        </div>
      </div>

      {/* TABLA */}
      <div className="bg-white p-5 rounded-2xl shadow border-l-4 border-secondary overflow-x-auto">

        <table className="min-w-full text-sm">

          <thead className="bg-secondary text-white">
            <tr>
              <th className="p-3 text-left">Nombre</th>
              <th className="p-3 text-left">Cédula</th>
              <th className="p-3 text-left">Empresa</th>
              <th className="p-3 text-left">Departamento</th>
              <th className="p-3 text-left">Motivo</th>
              <th className="p-3 text-left">Detalle</th>
              <th className="p-3 text-left">Entrada</th>
              <th className="p-3 text-left">Salida</th>
              <th className="p-3 text-left">Estado</th>
            </tr>
          </thead>

          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="9" className="text-center p-4 text-gray-500">
                  No hay registros
                </td>
              </tr>
            ) : (
              filtered.map((v) => (
                <tr key={v._id} className="border-t hover:bg-gray-50">

                  <td className="p-3">{v.name}</td>
                  <td className="p-3">{v.idNumber}</td>
                  <td className="p-3">{v.company}</td>
                  <td className="p-3">{v.department}</td>
                  <td className="p-3">{v.reason}</td>
                  <td className="p-3">{v.reasonDetail || "-"}</td>

                  <td className="p-3">
                    {v.entryTime
                      ? new Date(v.entryTime).toLocaleString()
                      : "-"}
                  </td>

                  <td className="p-3">
                    {v.exitTime
                      ? new Date(v.exitTime).toLocaleString()
                      : "-"}
                  </td>

                  <td className="p-3">
                    <span
                      className={`px-2 py-1 rounded text-white text-xs ${
                        v.status === "inside"
                          ? "bg-success"
                          : "bg-gray-500"
                      }`}
                    >
                      {statusMap[v.status] || v.status}
                    </span>
                  </td>

                </tr>
              ))
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
}